"use client"

import React, { useContext } from "react"
import { useTranslations } from "next-intl"
import { ModalContext } from "@/contexts/ModalProvider"

import Container from "../../Container/Container"
import RegularButton from "../../RegularButton/RegularButton"
import styles from "./CallToAction.module.scss"

export default function CallToAction() {
  const { setOpenModal } = useContext(ModalContext)
  const t = useTranslations()

  return (
    <section className={styles.CallToAction} id="CallToAction">
      <Container className={styles.CallToAction__container}>
        <h2 className={styles.CallToAction__text}>{t("calltoaction.text")}</h2>
        <RegularButton
          btnStyle="white"
          text={t("events.signUpButtonText")}
          onClick={() => setOpenModal(true)}
        ></RegularButton>
      </Container>
    </section>
  )
}
